<template>
  <v-container class="px-0 pt-0 mb-12 position-relative" style="background-color:#F0F0F0; min-height:100vh">
    <v-row class="mt-0 mb-2 py-5 text-center" no-gutters>
      <v-col class="text-left pl-2" cols="12">

        <div v-if="state.folderTags.length > 0" class="d-flex justify-center pa-4 text-center ga-4 flex-wrap">
          <v-sheet
            :style="{ 
              background: 'white', 
              boxShadow: '4px 4px 10px 0px #0000000D', 
              color: settingsStore.settings.primaryColor,
              border: state.selectFolderTag === 'all' ? `1px solid ${settingsStore.settings.primaryColor}` : ''
            }" 
            class="px-1 py-3 b-round-20 position-relative text-center"
            :class="{ 'border-class': state.selectFolderTag === 'all'}"
            width="100"
            @click="state.selectFolderTag = 'all'"
          >
            <v-icon class="my-2" icon="mdi mdi-file-document-outline" size="40"></v-icon>
            <p class="p-text-md">All files</p>
          </v-sheet>
    
          <div v-for="(folder, index) in state.folderTags" :key="`folder-${index}`">
            <v-sheet
              v-if="folder.visible_to_clinic"
              :style="{ 
                background: 'white', 
                boxShadow: '4px 4px 10px 0px #0000000D', 
                color: folder?.color,
                border: state.selectFolderTag === folder.id ? `1px solid ${settingsStore.settings.primaryColor}` : ''
              }" 
              class="px-1 py-3 b-round-20 position-relative text-center"
              width="100"
              @click="state.selectFolderTag = folder.id"
            >
              <v-icon class="my-2" icon="mdi mdi-file-document-outline" size="40"></v-icon>
              <p class="p-text-md ellipsis">{{ folder.name }}</p>
              <p v-if="folder?.unviewed_count" class="position-absolute badge">
                {{ folder?.unviewed_count }}
              </p>
            </v-sheet>
          </div>
        </div>
      </v-col>
      
      <v-col class="text-left pl-2" cols="12">
        <v-card-title class="font-size-18-600">
          Recent Documents
        </v-card-title>
      </v-col>

      <v-col cols="12">
        <SearchFilter @update:modelValue="(val: string) => state.search = val"/>
      </v-col>
      <v-col class="d-flex px-3" cols="12">
        <v-col class="mt-1 position-relative left-filter-text" @click="()=>state.filterSelected = 'sort'">
          <ButtonFilterSelect
              v-model="sortTabSelectedValue"
              :is-tab-selected="isSortTabSelected"
              :items="sortValues"
              :multiple="false"
              :text="sortTabSelectedValue"
              icon="sort-icon"
              single-line
          />
        </v-col>
        <v-col class="mt-1 position-relative left-filter-text" @click="()=> state.filterSelected = 'filter'">
          <ButtonFilterSelect
              v-model="filterTabSelectedValue"
              :is-tab-selected="isFilterTabSelected"
              :items="filters"
              :multiple="false"
              :text="filterTabSelectedValue"
              single-line
          />
        </v-col>
      </v-col>
    </v-row>

    <template v-if="loading">
      <section v-for="n in 5" :key="n" class="mt-4 mx-4 mb-3">
        <v-card class="mt-2 mx-2 mb-2 pa-4 border-rounded">
          <v-row class="my-0 align-center" no-gutters>
            <v-col cols="8" class="px-3">
              <v-skeleton-loader type="text" width="80%" class="mb-2" />
              <v-skeleton-loader type="text" width="40%" />
            </v-col>
            <v-col cols="4" class="text-end px-3">
              <v-skeleton-loader type="button" width="90" />
            </v-col>
          </v-row>
        </v-card>
      </section>
    </template>

    <section v-else v-for="document in state.items" :key="document.id" class="mt-4 mx-4 mb-3">
      <v-card v-if="document.file_resource"
              class="mt-2 mx-2 mb-2 pa-4 border-rounded">
        <v-row class="my-0" no-gutters>
          <v-col cols="12">
            <v-row class="align-center">
              <v-col class="px-3">

                <div class="d-flex ga-2">
                  <p v-if="document.viewed_by_client == 0" class="mt-2 unread"></p>

                  <div>
                    <p :class="{'font-size-16-600':	document.viewed_by_client == 0, 'font-size-14-400': 	document.viewed_by_client == 1}">
                      {{ document.file_resource.title }}
                    </p>

                    <p class="font-size-10-400 font-grey-dark" style="margin-top: 2px">
                      {{ moment(document.created_at).format('DD MMM YYYY') }}
                    </p>

                    <p 
                      v-if="document.file_resource.tag"
                      class="font-size-10-400 mt-2 folder-tag" 
                      :style="{
                        backgroundColor: document.file_resource.tag?.color
                      }"
                    >
                      {{ document.file_resource.tag?.name }}
                    </p>
                  </div>
                </div>
              </v-col>
              <v-col class="text-end px-3">
                <v-btn
                    class="text-white b-round-20 outline-btn white-btn"
                    elevation="0"
                    height="32px"
                    x-small
                    @click="openFile(document)"
                >
                  {{ document?.file_resource?.kind == 'plan' ? 'View' : 'Download' }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </section>

    <v-card v-if="!loading && state.items.length == 0" class="mt-4 mx-4 mb-3" height="50vh">
      <v-row class="my-2 py-1" no-gutters>
        <v-col class="my-1 px-10 text-center" cols="12">
          <v-alert type="info" variant="tonal">No Documents Available</v-alert>
        </v-col>
      </v-row>
    </v-card>

    <div v-if="state.pagination.next_page_url" class="text-center">
      <v-btn
          :ripple="false"
          class="load-more text-capitalize font-size-12-600"
          variant="plain"
          @click="seeMore"
      >
        Load More
      </v-btn>
    </div>

    <ButtonFixed
        color-icon="primaryButtonColor"
        custom-class="text-white primary-button"
        custom-icon-class="add-new-circle-icon"
        icon="add-plus-circle"
        text="Upload Document"
        @click="router.push({ name: 'document-upload' })"
    />
  </v-container>
</template>

<script lang="ts" setup>
import {computed, reactive, ref, shallowRef, watch} from 'vue';
import {filesService} from '@/api/services/file';
import {useSettingsStore} from '@/api/store/settings';
import {sortValues} from "@/views/OrdersComponents/Helpers";
import ButtonFilterSelect from "@/components/custom/ButtonFilterSelect/ButtonFilterSelect.vue";
import SearchFilter from "@/components/custom/SearchFilter.vue";
import debounce from 'lodash/debounce';
import moment from "moment/moment";
import {useRouter} from "vue-router";
import ButtonFixed from "@/components/custom/ButtonFixed.vue";
import RoundButton from "@/components/custom/RoundButton.vue";

const settingsStore = useSettingsStore();
const router = useRouter();

const loading = ref(false);

const setAppColor = settingsStore.settings.buttonColor2

const filters = [
  {
    name: 'Filter',
    label: 'All'
  },
  {
    name: 'created_at',
    label: 'Date'
  },
  {
    name: 'id',
    label: 'Id'
  },
]

// Data
const state = reactive({
  items: [] as any[],
  pagination: {
    meta: {},
    links: [],
    next_page_url: null,
  },
  search: '' as string,
  filterSelected: 'filter' as string,
  selectFolderTag: 'all' as number|string,
  folderTags: [] as any[],
});

const sortTabSelectedValue = shallowRef({
  name: 'Sort',
  label: 'Sort'
})
const filterTabSelectedValue = shallowRef({
  name: 'Filter',
  label: 'Filter'
})
const page = shallowRef(1)

// Computed
const isFilterTabSelected = computed(() => {
  return state.filterSelected === 'filter'
});

const isSortTabSelected = computed(() => {
  return state.filterSelected === 'sort'
});

const filterQueryString = computed(() => {
  let filter = {
    sorting: '',
    search: state.search,
    page: page.value,
    kind: 'documents',
    tag: state.selectFolderTag
  };

  let sortOrder = sortTabSelectedValue.value.name === 'Sort' ? 'desc' : sortTabSelectedValue.value.name;

  let filterValue = filterTabSelectedValue.value.name === 'Filter' ? 'title' : filterTabSelectedValue.value.name;

  if (filterTabSelectedValue.value.name === 'Filter' && sortTabSelectedValue.value.name === 'Sort') {
    filter.sorting = 'id,desc';
  } else {
    filter.sorting = `${filterValue},${sortOrder}`;
  }

  return filter;
});

const getFiles = () => {
  loading.value = true;

  filesService.index(filterQueryString.value).then((response) => {
    state.items.push(...response.data)
    state.pagination.meta = response.meta;
    state.pagination.links = response.links;
    state.pagination.next_page_url = response.links.next;
  }).finally(() => {
    loading.value = false;
  });

  filesService.getFolderTags({ skipGlobalLoading: true }).then((response) => {
    state.folderTags = response.data;
  });
}

// Debounced to fetch getMedicalAlerts
const debouncedGetOrders = debounce(getFiles, 300);

const resetState = () => {
  page.value = 1;
  state.items = [];
  loading.value = true;
}

const seeMore = () => {
  if (state.pagination.next_page_url) {
    page.value++;
    getFiles();
  }
}

const openFile = (file: any) => {

  if (file.file_resource?.kind == 'plan') {
    router.push({name: 'document-viewer', params: {id: file.file_resource.model_id}});
  } else {
    // Handle file through browser window - may require FileSystem integration
    window.open(file.file_resource?.file.file_path, '_blank');
  }

  if (file.viewed_by_client == 0) {
    filesService.viewedByClient(file.client_id, file.file_resource_id).then(() => {
      state.items = state.items.map((item) => {
        if (item.id == file.id) {
          item.viewed_by_client = 1;
        }
        return item;
      })
    })
  }

}

watch(() => [filterTabSelectedValue.value, sortTabSelectedValue.value, state.search, state.selectFolderTag], () => {
  resetState();
  debouncedGetOrders();
});

getFiles();
</script>

<style lang="scss" scoped>
:deep(.add-new-circle-icon) {
  margin-right: 3px;
}

.left-filter-text {
  :deep(.v-btn) {
    justify-content: left;
  }
}

.load-more {
  padding: 10px;
  text-align: center;
  margin: 10px auto 30px auto;
  width: 200px;
  color: v-bind(setAppColor);
  text-decoration: underline;
  text-underline-offset: 2px;
  opacity: 1;
}

.left-filter-text, .right-filter-text {
  :deep(.v-btn) {
    background: white;
  }
}

.unread {
  background: #1EBCD5;
  height: 7px;
  width: 7px;
  border-radius: 50%;
}

.border-rounded {
  border-radius: 8px;
  border: 1px solid #E0E4E9;
  box-shadow: none;
}

.badge {
  background: linear-gradient(0deg, #EC5151, #EC5151),
  linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%);
  color: #fff;
  border-radius: 50%;
  width: 17px;
  height: 17px;
  font-size: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 10px;
  right: 10px;
  position: absolute;
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.folder-tag {
  width: fit-content;
  padding: 4px 8px;
  border-radius: 10px;
  color: #ffffff;
}

.ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>